export default __webpack_public_path__ + "images/a540a91326896aaf130642d281cddcda.svg";